var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "data-others__container" },
    [
      _c("JadeGroupHeader", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm.data.attemptCount >= 0
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("card.attempt-count"),
              trailing: _vm.data.attemptCount,
            },
          })
        : _vm._e(),
      _vm.data.attemptCount >= 0 ? _c("JadeDivider") : _vm._e(),
      _vm.data.description ? _c("JadeDivider") : _vm._e(),
      _vm.data.description
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("cash.description"),
              trailing: _vm.data.description,
            },
          })
        : _vm._e(),
      _vm.data.nextAttempt ? _c("JadeDivider") : _vm._e(),
      _vm.data.nextAttempt
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("card.next-attempt"),
              trailing: _vm._f("dateFormat")(
                _vm.data.nextAttempt,
                "dateAndHour"
              ),
            },
          })
        : _vm._e(),
      _vm.data.paidAtDate ? _c("JadeDivider") : _vm._e(),
      _vm.data.paidAtDate
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("boleto.paid-at"),
              trailing: _vm._f("dateFormat")(_vm.data.paidAtDate, "date"),
            },
          })
        : _vm._e(),
      _vm.data.paidAtDateHour ? _c("JadeDivider") : _vm._e(),
      _vm.data.paidAtDateHour
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("boleto.paid-at"),
              trailing: _vm._f("dateFormat")(
                _vm.data.paidAtDateHour,
                "dateAndHour"
              ),
            },
          })
        : _vm._e(),
      _vm.data.captureMethod ? _c("JadeDivider") : _vm._e(),
      _vm.data.captureMethod
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("capture-method.title"),
              trailing: _vm.$t(`capture-method.${_vm.data.captureMethod}`),
            },
          })
        : _vm._e(),
      _vm.data.deviceSerialNumber ? _c("JadeDivider") : _vm._e(),
      _vm.data.deviceSerialNumber
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("capture-method.terminal-number"),
              trailing: _vm.data.deviceSerialNumber,
            },
          })
        : _vm._e(),
      _vm.data.pgid ? _c("JadeDivider") : _vm._e(),
      _vm.data.pgid
        ? _c("JadeListItem", {
            attrs: { label: _vm.$t("pix"), trailing: _vm.data.pgid },
          })
        : _vm._e(),
      _vm.data.endToEndId ? _c("JadeDivider") : _vm._e(),
      _vm.data.endToEndId
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("pix-bacen"),
              trailing: _vm.data.endToEndId,
            },
          })
        : _vm._e(),
      _c("JadeDivider", { attrs: { size: "medium" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }